import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'
import {toastr} from 'react-redux-toastr'

import MissionForm from '../../Forms/MissionForm/MissionForm.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'
import SubmitButton from '../../Forms/MissionForm/SubmitButton.jsx'

import withCurrentUniverse from '../../../HOC/withCurrentUniverse.jsx'

import api from '../../../../api.js'

import {
  defaultMissionTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/defaultMissionTemplate.js"
import {
  purchaseTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/purchaseTemplate.js"
import {
  humanResourceTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/humanResourceTemplate.js"
import {
  financeTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/financeTemplate.js"
import {
  engineeringTemplate
} from "../../../containers/Freelance/RegistrationStep/Missions/MissionTemplates/engineeringTemplate.js"
import PropTypes from "prop-types"

const universeTemplate = [
  {code: 'purchase', template: purchaseTemplate},
  {code: 'finance', template: financeTemplate},
  {code: 'hr', template: humanResourceTemplate},
  {code: 'engineering', template: engineeringTemplate},
]

class MissionModal extends Modal {
  static propTypes = {
    currentUniverse: PropTypes.object.isRequired,
    onClose: PropTypes.func
  }

  static getDerivedStateFromProps(props, state) {
    if (props.beautifyPromise && props.beautifyPromise !== state.activeBeautifyPromise) {
      return {
        beautifying: true,
        beautifiedDescription: null,
        activeBeautifyPromise: props.beautifyPromise
      }
    }
    if (!props.beautifyPromise && state.activeBeautifyPromise) {
      return {
        beautifying: false,
        beautifiedDescription: null,
        activeBeautifyPromise: null
      }
    }
    return null
  }

  constructor(props) {
    super(props)

    this.state = {
      universeTemplate: defaultMissionTemplate,
      beautifying: false,
      beautifiedDescription: null,
      activeBeautifyPromise: null
    }

    this.close = () => this.props.closeModal(true)

    this.onClose = () => {
      if (this.props.onClose) {
        this.props.onClose(this.props.experiences)
      }
      this.props.closeModal()
    }
  }

  componentDidUpdate(prevProps) {
    if(!this.props || !this.props.currentUniverse || !this.props.currentUniverse.code ){
      return
    }
    const universeCode = this.props.currentUniverse.code
    const found = universeTemplate.find((universe) => universe.code === universeCode)
    if (!found) {return}
    this.setState({universeTemplate: found.template})

    if (this.props.beautifyPromise && this.props.beautifyPromise !== prevProps.beautifyPromise) {
      this.props.beautifyPromise
        .then(response => {
          this.setState({
            beautifiedDescription: response.data.beautified,
            beautifying: false
          })
        })
        .catch(e => {
          console.error(e)
          this.setState({ beautifying: false })
        })
    }
  }

  onSubmitSuccess = () => {
    let action = 'créée'
    if (this.props.offset !== undefined) {
      action = 'modifiée'
    }

    toastr.success('La mission a été ' + action + ' avec succès.')
    this.close()
  }

  onSubmitModal = async (values) => {
    if (this.state.beautifying) return
    this.setState({ loading: true })
    values.locality = values?.locality?.[0]?.label ?? values?.locality ?? null

    let response = null
    const experiences = this.props?.experiences?.length ? this.props.experiences : []

    if (this.props.offset !== undefined) {
      try {
        const { id, created_at, updated_at, ...rest } = values
        delete rest.dateFormat

        response = await api.freelances.experiences.edit(rest, {
          freelance: this.props.freelance.id,
          experience: this.props.experienceId
        })

        experiences[this.props.offset] = response?.data
      } finally {
        this.setState({ loading: false })

        if(this.props.onClose) {
          this.props.onClose(experiences)
        }

        this.props.closeModal()
      }
    } else {
      try {
        response = await api.freelances.experiences.add(values, {
          freelance: this.props.freelance.id
        })

        experiences.push(response?.data)
      } finally {
        this.setState({ loading: false })

        if(this.props.onClose) {
          this.props.onClose(experiences)
        }

        this.props.closeModal()
      }
    }
  }

  render() {
    if (!this.props.freelance) {
      return null
    }
    const experience = (this.props.offset !== undefined && this.props.experiences[this.props.offset]) ?
      this.props.experiences[this.props.offset] : {}

    const description = this.state.beautifiedDescription
      ?? (experience.description ? experience.description : this.state.universeTemplate)

    return (
      <BootstrapModal
        toggle={this.props.closeModal}
        isOpen={this.props.isOpen}
        className="mission-modal modal-lg"
        backdrop={'static'}
      >
        <ModalHeader toggle={this.props.closeModal}>Mission</ModalHeader>
        <ModalBody>
          <MissionForm
            onSubmitSuccess={this.onSubmitSuccess}
            initialValues={{
              ...experience,
              description
            }}
            enableReinitialize={!!this.props.beautifyPromise}
            onSubmit={this.onSubmitModal}
            onClose={this.onClose}
            beautifying={this.state.beautifying}/>
          <div className="text-center">
            { this.state.beautifying }
            <SubmitButton className="btn btn-primary my-3" disabled={this.state.beautifying}>
              Enregistrer
            </SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default withCurrentUniverse(MissionModal)
